var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40015 3.99999C5.40015 3.66862 5.66878 3.39999 6.00015 3.39999H16.0001C16.3315 3.39999 16.6001 3.66862 16.6001 3.99999V14C16.6001 14.3314 16.3315 14.6 16.0001 14.6C15.6688 14.6 15.4001 14.3314 15.4001 14V5.4485L4.42416 16.4243C4.18985 16.6586 3.80995 16.6586 3.57563 16.4243C3.34132 16.1899 3.34133 15.81 3.57564 15.5757L14.5516 4.59999H6.00015C5.66878 4.59999 5.40015 4.33136 5.40015 3.99999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.1557dcd6c0c9faff3ac322fbb0a6baec.svg";
export { ForwardRef as ReactComponent };